import { decode, encode } from 'base-64'

// @ts-ignore
if (!global.btoa) {
	// @ts-ignore
	global.btoa = encode
}

// @ts-ignore
if (!global.atob) {
	// @ts-ignore

	global.atob = decode
}

export { default as connectFuego } from './HOC/connectFuego/index'
export { default as useFuego } from './hooks/useFuego/index'
export { default as FuegoProvider } from './FuegoProvider/index'
export { default as GetFuego } from './components/GetFuego/index'
export { default as Fuego } from './Fuego/index'
export { default as FuegoQuery } from './FuegoQuery/index'
export * from './FuegoQuery/types'

export { default as useFuegoContext } from './hooks/useFuegoContext'
// export { default as useOnlineStatus } from './hooks/useOnlineStatus'
export { default as FuegoGate } from './components/FuegoGate'
export { default as connectFuegoGate } from './HOC/connectFuegoGate'

// export {
//     default as dangerouslyEnablePeristenceOnExpoAsync
// } from './persistence'

// export // connectFuego,
// useFuego,
// FuegoProvider,
// GetFuego,
// Fuego,
// FuegoQuery,
// QueryTypes
// {}
